// action/locationData/locationSelector.js
export const selectLocationArr = (state) => state.locationDataArr.locationArr;
